import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import appStyles from '@app.registration/Registration.module.scss';

const MainNav = ({ routes }) => {
  let filteredRoutes = routes.filter((item) => item.includeInNav);

  return (
    <div className={appStyles.app_header}>
      <div className="Container">
        <div className={appStyles.main_nav}>
          {filteredRoutes.map((route, index) => (
            <NavLink key={index} to={route.path}>
              {route.name}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MainNav;
